import { noData } from 'src/app/models/placeholder';
import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { NavController } from '@ionic/angular';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
import { Router } from '@angular/router';
@Component({
  selector: 'no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
})
export class NoDataComponent implements OnInit {
  @Input() message: string;
  @Input() backUrl: string;
  @Input() componentHeight = '100%';
  @Input() showModalCloseBtn: boolean;
  @Input() imcomingImage: string;
  @Input() fallbackCTA!: string;
  @Input() forceFullReloadOnCta: boolean = false;
  public image: string;
  public partnerPid:string
  clientName: any;
  url: any;

  constructor(
    private modalController: ModalController,
    private translate: TranslateService,
    private navControl: NavController,
    private themeService: ThemeService,
    private router: Router
  ) {
    if (!this.message) {
      this.translate.get('no_data.no_results_mssg').subscribe((res: string) => {
        this.message = res;
      });
    }
    if (!this.backUrl) {
      this.backUrl = 'home';
    }
  }

  ngOnInit() {
    this.url = this.router.url;
    this.clientName = this.themeService.getClientName;
    this.partnerPid = this.themeService.getAppPid;
    if (this.imcomingImage) {
      this.image = this.imcomingImage;
    } else {
      this.image = noData;
    }
  }

  closeModal() {
    // this.airportListService.setSelectedAirport(selectedAirport.airportCode);
    this.navControl.navigateBack(this.backUrl);
    // this.modalController.dismiss();
  }

  navigateToBackUrlWithReload(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const url = this.backUrl?.startsWith('/') ? this.backUrl : `/${this.backUrl}`;
    if (this.forceFullReloadOnCta) {
      window.location.assign(url);
    } else {
      this.router.navigateByUrl(url);
    }
  }
}
